import { pxToNumber, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { UmbrellaPaymentMethodSelection } from '../UmbrellaPaymentMethodSelection'

export const PaymentMethodWrapper = styled(UmbrellaPaymentMethodSelection)`
  margin-top: ${pxToNumber(Spacing.S40) - pxToNumber(Spacing.S4)}px;
  margin-bottom: auto;
  position: sticky;
  top: 0;
`
